import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommercePaymentMethodsEntityState} from "../reducers/ecommerce-payment-methods.reducer";
import {getTenWebProductState} from "./ten-web-product.selector";
import {getWebsiteProductState} from "./website-product.selector";
import {ITenWebProductState} from "../reducers/ten-web-product.reducer";
import {IWebsiteProductState} from "../reducers/website-product.reducer";
import {Product, ProductType} from "../../websites/website/product";
import {Config} from "../../config/config";
import {ProductMapper} from "../../websites/website/product-mapper";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePaymentMethodsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePaymentMethods.entities[websiteId]);

export const getEcommerceAllPaymentMethods = (websiteId: number) => createSelector(getEcommercePaymentMethodsState(websiteId),
  (state: IEcommercePaymentMethodsEntityState) => {
     const data = state?.data ? state.data.filter(paymentMethod => Config.includedPaymentIds.includes(paymentMethod?.id)): [];
     return data
}
);

export const getWebsiteWooPaymentsPlugin = (websiteId: number) => createSelector([getTenWebProductState, getWebsiteProductState],
  (tenWebProductState: ITenWebProductState, websiteProductState: IWebsiteProductState) => {
    const websitePluginsMap: { [slug: string]: any } = websiteProductState && websiteProductState.entities && websiteProductState.entities[websiteId] ? websiteProductState.entities[websiteId].pluginEntities : {};
    const websiteWooPaymentsPlugin: Product = websitePluginsMap[Config.woocommercePaymentsPluginSlug] ? ProductMapper.mapWordpressProduct(websitePluginsMap[Config.woocommercePaymentsPluginSlug], ProductType.PLUGIN) : null;
    return websiteWooPaymentsPlugin;
  }
);

export const getEcommercePaymentMethodsLoading = (websiteId: number) => createSelector(getEcommercePaymentMethodsState(websiteId),
  (state: IEcommercePaymentMethodsEntityState) => state && state.loading
);

export const getEcommercePaymentMethodsLoaded = (websiteId: number) => createSelector(getEcommercePaymentMethodsState(websiteId),
  (state: IEcommercePaymentMethodsEntityState) => state && state.loaded
);
